(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[60681],{

/***/ 31701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67379);
/* harmony import */ var _footer_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66081);
/* harmony import */ var _footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75094);








const yearNow = new Date();
function Footer({ textColor , bgColor , addCcpaPrivacyNotice  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_2__/* .useModal */ .d)();
    const { domain , pageType , locale , defaultLocale , domainNameTranslation  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const { visitDetails , routeConfig , category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const privacyPolicyLabel = category?.config?.privacyPolicyLabel ?? category?.parentCategory?.config?.privacyPolicyLabel;
    const disclaimerNote = domain?.config?.disclaimerNote ?? null;
    let contactUsLink = null;
    if (visitDetails?.trafficSourceNetwork?.toLowerCase() === "outbrain" || category?.slug === "home-security" || domain?.name === "bestcontractors.com") {
        contactUsLink = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "cursor-pointer",
            href: "/contact-us",
            children: "Contact Us"
        });
    }
    let footerLinks = [
        {
            title: domain?.translations?.[`${domainNameTranslation}_TermsConditions`] ?? "Terms & Conditions",
            onClick: ()=>setModal({
                    active: true,
                    content: "terms"
                })
        },
        {
            title: privacyPolicyLabel || domain?.translations?.[`${domainNameTranslation}_PrivacyPolicy`] || "Privacy Policy",
            onClick: ()=>setModal({
                    active: true,
                    content: "privacy"
                })
        },
        // only show partner-with-us when its not on the partner-with-us page
        ...pageType !== "partner-with-us" ? [
            {
                title: domain?.translations?.[`${domainNameTranslation}_PartnerWithUs`] ?? "Partner with Us",
                href: locale === (defaultLocale ?? "en") ? "/partner-with-us" : `/${locale}/partner-with-us`
            }, 
        ] : [], 
    ];
    if (domain?.config?.isBranded) {
        footerLinks = footerLinks.filter((link)=>link.title !== "Partner with Us");
    }
    const ccpaTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "custom-domain-ccpa-privacy-notice" || textBlock.position === "custom-category-ccpa-privacy-notice");
    if (addCcpaPrivacyNotice || ccpaTextBlock) {
        footerLinks.push({
            title: "CCPA Privacy Notice",
            onClick: ()=>setModal({
                    active: true,
                    content: "ccpaPrivacyNotice"
                })
        });
    }
    (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_4__/* .injectDoNotSellInFooter */ .Du)({
        footerArray: footerLinks,
        pageType: pageType,
        trafficSource: visitDetails?.trafficSource,
        hideDoNotSell: domain.config?.hideDoNotSell,
        domain: domain,
        visitDetails: visitDetails,
        domainNameTranslation: domainNameTranslation,
        locale: locale,
        defaultLocale: defaultLocale,
        routeConfig: routeConfig
    });
    const variables = routeConfig?.config?.footer?.variables;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        style: {
            color: textColor,
            backgroundColor: bgColor,
            ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_5__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
        },
        className: `${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footer)}  text-center lg:px-6 lg:py-0`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: `${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper)} max-w-7xl mx-auto`,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inner)} lg:flex lg:justify-between lg:items-center flex-row-reverse ${!bgColor ? "border-t" : ""} lg:mx-auto px-4 lg:px-0 py-6 pb-36 lg:py-4 ltrStyle`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `footer-menu ${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["footer-menu"])}`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: "flex justify-center flex-col md:flex-row mb-3 lg:mb-0 children:last:border-r-0 ltrStyle",
                            children: [
                                footerLinks.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: `px-2 pb-2 md:pb-0 font-medium lg:font-light text-sm lg:leading-4 ${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item"])} `,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: " cursor-pointer",
                                            onClick: item.onClick,
                                            href: item.href,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: item.title
                                            })
                                        })
                                    }, index)),
                                contactUsLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: `px-2 font-medium lg:font-light text-sm lg:leading-4 ${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item"])} `,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: contactUsLink
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-light text-sm",
                        children: disclaimerNote ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_4__/* .replacePlaceholders */ .wT)(disclaimerNote)
                            }
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "\xa9"
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: yearNow.getFullYear()
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: `https://${domain.name}`,
                                    children: domain.niceName
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 66081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"footer_menu-item__PuRF4","footer":"footer_footer__4Qyt9","inner":"footer_inner__ZnSSe","wrapper":"footer_wrapper__vsYp1","footer-menu":"footer_footer-menu__cG5mD"};

/***/ })

}]);